import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { Course } from "src/app/interfaces/response";
import { OrganismsService } from "src/app/services/organisms.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-organismos-table-principal",
  templateUrl: "./organismos-table-principal.component.html",
  styleUrls: ["./organismos-table-principal.component.css"],
})
export class OrganismosTablePrincipalComponent implements OnInit {
  displayedColumns: string[] = ["nombreCurso", "capacitador", "estandares"];
  dataSource = new MatTableDataSource<Course>();
  totalElements: number = 0;
  pageSize: number = 30;
  pageNumber: number = 0;
  search: string = "";
  debounceTimer: any;
  filterTimeout: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Output() courseSelected = new EventEmitter<Course>();
  activeEror: boolean;

  constructor(private service: OrganismsService, private router: Router) {}

  ngOnInit(): void {
    window.scroll(0, 0);
    this.getOrganisms(this.pageNumber, this.pageSize, this.search);
  }

  public sectorByID(organism: any) {
    this.router.navigate(["/detalleOrganismo", organism.prestadorServicio]);
  }

  public standarById(entity: any): void {
    localStorage.setItem("standard-organismos", entity.razonSocial);
    this.router.navigate(["/estandaresOrganismos", entity.prestadorServicio]);
  }

  public onPageChange(event: PageEvent): void {
    this.getOrganisms(event.pageIndex, event.pageSize, this.search);
  }

  public applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.getOrganisms(0, this.pageSize, filterValue);
    }, 800);
  }

  private async getOrganisms(
    pageNumber: number,
    size: number,
    search: string
  ): Promise<void> {
    try {
      const entities = await this.service.getOrganismsList(
        pageNumber,
        size,
        search
      );
      this.totalElements = entities.totalElements;
      this.dataSource.data = entities.content;
      if (!entities.content || entities?.content?.length === 0) {
        this.activeEror = true;
      } else {
        this.activeEror = false;
      }
    } catch (error) {
      console.error("Error al obtener cursos:", error);
    }
  }
}
